import urlConstants from '~/lib/constants/url.constants';

import api from '../api';

export type CodeAndLabel = {
  code: string;
  label: string;
};

export type CodeAndLabelWithSortOrder = CodeAndLabel & {
  sortOrder: number;
};

export type SecondaryDischargeReason = CodeAndLabelWithSortOrder & {
  primaryDischargeReason: PrimaryDischargeStatusReason;
};

export type PrimaryDischargeStatusReason = {
  statusReasonName: string;
  statusReasonExternalId: string;
};

// All Discharge Plan Reference Data API resources live under "/clinical-data/ref-discharge-plans"
export const dischargePlanApi = api.injectEndpoints({
  endpoints: (build) => ({
    getIsPatientSeekingCares: build.query<CodeAndLabelWithSortOrder[], void>({
      query: () => ({
        method: 'GET',
        url: urlConstants.clinical_data.ref_discharge_plans
          .is_patient_seeking_cares,
      }),
    }),
    getLevelsOfCare: build.query<CodeAndLabelWithSortOrder[], void>({
      query: () => ({
        method: 'GET',
        url: urlConstants.clinical_data.ref_discharge_plans.levels_of_care,
      }),
    }),
    getSecondaryReasons: build.query<SecondaryDischargeReason[], void>({
      query: () => ({
        method: 'GET',
        url: urlConstants.clinical_data.ref_discharge_plans.secondary_reasons,
      }),
    }),
    getTypesOfCare: build.query<CodeAndLabelWithSortOrder[], void>({
      query: () => ({
        method: 'GET',
        url: urlConstants.clinical_data.ref_discharge_plans.types_of_care,
      }),
    }),
    getWhoInitiatedDischarges: build.query<CodeAndLabel[], void>({
      query: () => ({
        method: 'GET',
        url: urlConstants.clinical_data.ref_discharge_plans
          .who_initiated_discharges,
      }),
    }),
  }),
});

export const {
  useGetIsPatientSeekingCaresQuery,
  useGetLevelsOfCareQuery,
  useGetSecondaryReasonsQuery,
  useGetTypesOfCareQuery,
  useGetWhoInitiatedDischargesQuery,
} = dischargePlanApi;
